import React from "react";
import ReactbootstapButton from 'react-bootstrap/Button';
import styles from "./Button.module.scss";

const Button = props => (
  <ReactbootstapButton
    variant="primary"
    size="lg"
    onClick={props.onClick}
    bsPrefix={`${styles.btnPortal} ${props.big
      ? styles.btnPortalBig : ''} ${props.secondary
      ? styles.btnPortalSecondary : ''} ${props.className || ''}`}
    disabled={props.disabled}
  >
    {props.children}
  </ReactbootstapButton>
);

export default Button;



